{
  "HELP_CENTER": {
    "TITLE": "Helpcentrum",
    "NEW_PAGE": {
      "DESCRIPTION": "Maak selfservice helpcentrum-portals voor je klanten. Help hen snel antwoorden te vinden, zonder te wachten. Stroomlijn vragen, verhoog de efficiëntie van medewerkers en verbeter de klantenservice.",
      "CREATE_PORTAL_BUTTON": "Portal aanmaken"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Naamloos"
    },
    "HEADER": {
      "FILTER": "Filteren op",
      "SORT": "Sorteren op",
      "LOCALE": "Taal",
      "SETTINGS_BUTTON": "Instellingen",
      "NEW_BUTTON": "Nieuw artikel",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Gepubliceerd",
        "DRAFT": "Draft",
        "ARCHIVED": "Gearchiveerd"
      },
      "TITLES": {
        "ALL_ARTICLES": "Alle artikelen",
        "MINE": "Mijn artikelen",
        "DRAFT": "Draft-artikelen",
        "ARCHIVED": "Gearchiveerde artikelen"
      },
      "LOCALE_SELECT": {
        "TITLE": "Selecteer taal",
        "PLACEHOLDER": "Selecteer taal",
        "NO_RESULT": "Geen taal gevonden",
        "SEARCH_PLACEHOLDER": "Zoek taal"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Alle artikelen",
      "PUBLISH_BUTTON": "Publiceren",
      "MOVE_TO_ARCHIVE_BUTTON": "Verplaatsen naar archief",
      "PREVIEW": "Voorbeeld",
      "ADD_TRANSLATION": "Vertaling toevoegen",
      "OPEN_SIDEBAR": "Zijbalk openen",
      "CLOSE_SIDEBAR": "Zijbalk sluiten",
      "SAVING": "Opslaan...",
      "SAVED": "Opgeslagen"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Afbeelding uploaden",
        "UPLOADING": "Uploaden...",
        "SUCCESS": "Afbeelding succesvol geüpload",
        "ERROR": "Fout bij het uploaden van de afbeelding",
        "UN_AUTHORIZED_ERROR": "Je bent niet bevoegd om afbeeldingen te uploaden",
        "ERROR_FILE_SIZE": "De afbeeldingsgrootte moet kleiner zijn dan {size}MB",
        "ERROR_FILE_FORMAT": "Afbeeldingsformaat moet jpg, jpeg of png zijn",
        "ERROR_FILE_DIMENSIONS": "Afbeeldingsafmetingen moeten kleiner zijn dan 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Anker invoegen",
        "TITLE": "Anker invoegen",
        "SUBMIT": "Invoegen",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Artikelinstellingen",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Categorie",
          "TITLE": "Selecteer categorie",
          "PLACEHOLDER": "Selecteer categorie",
          "NO_RESULT": "Geen categorie gevonden",
          "SEARCH_PLACEHOLDER": "Zoek categorie"
        },
        "AUTHOR": {
          "LABEL": "Auteur",
          "TITLE": "Selecteer auteur",
          "PLACEHOLDER": "Selecteer auteur",
          "NO_RESULT": "Geen auteurs gevonden",
          "SEARCH_PLACEHOLDER": "Zoek auteur"
        },
        "META_TITLE": {
          "LABEL": "Metatitel",
          "PLACEHOLDER": "Voeg een metatitel toe"
        },
        "META_DESCRIPTION": {
          "LABEL": "Metabeschrijving",
          "PLACEHOLDER": "Voeg je metabeschrijving toe voor betere SEO-resultaten..."
        },
        "META_TAGS": {
          "LABEL": "Metatags",
          "PLACEHOLDER": "Voeg metatags toe, gescheiden door komma's..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Artikel archiveren",
        "DELETE": "Artikel verwijderen"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Zonder categorie",
      "SEARCH_RESULTS": "Zoekresultaten voor {query}",
      "EMPTY_TEXT": "Zoek naar artikelen om in te voegen in antwoorden.",
      "SEARCH_LOADER": "Zoeken...",
      "INSERT_ARTICLE": "Invoegen",
      "NO_RESULT": "Geen artikelen gevonden",
      "COPY_LINK": "Kopieer artikellink naar klembord",
      "OPEN_LINK": "Open artikel in nieuw tabblad",
      "PREVIEW_LINK": "Voorbeeld van artikel"
    },
    "PORTAL": {
      "HEADER": "Portals",
      "DEFAULT": "Standaard",
      "NEW_BUTTON": "Nieuwe portal",
      "ACTIVE_BADGE": "actief",
      "CHOOSE_LOCALE_LABEL": "Kies een taal",
      "LOADING_MESSAGE": "Portals laden...",
      "ARTICLES_LABEL": "artikelen",
      "NO_PORTALS_MESSAGE": "Er zijn geen portals beschikbaar",
      "ADD_NEW_LOCALE": "Voeg een nieuwe taal toe",
      "POPOVER": {
        "TITLE": "Portals",
        "PORTAL_SETTINGS": "Portalinstellingen",
        "SUBTITLE": "Je hebt meerdere portals en kunt voor elke portal verschillende talen instellen.",
        "CANCEL_BUTTON_LABEL": "Annuleren",
        "CHOOSE_LOCALE_BUTTON": "Kies taal"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "artikelen",
            "ADD": "Taal toevoegen",
            "VISIT": "Site bezoeken",
            "SETTINGS": "Instellingen",
            "DELETE": "Verwijderen"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Portalconfiguraties",
            "ITEMS": {
              "NAME": "Naam",
              "DOMAIN": "Aangepast domein",
              "SLUG": "Slug",
              "TITLE": "Portal titel",
              "THEME": "Themakleur",
              "SUB_TEXT": "Portal subtekst"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Beschikbare talen",
            "TABLE": {
              "NAME": "Taalnaam",
              "CODE": "Taalcode",
              "ARTICLE_COUNT": "Aantal artikelen",
              "CATEGORIES": "Aantal categorieën",
              "SWAP": "Wisselen",
              "DELETE": "Verwijderen",
              "DEFAULT_LOCALE": "Standaard"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Portal verwijderen",
          "MESSAGE": "Weet je zeker dat je deze portal wilt verwijderen",
          "YES": "Ja, portal verwijderen",
          "NO": "Nee, portal behouden",
          "API": {
            "DELETE_SUCCESS": "Portal succesvol verwijderd",
            "DELETE_ERROR": "Fout bij het verwijderen van de portal"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Portal bewerken",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Basisinformatie"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Portal aanpassen"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Categorieën"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Talen"
          }
        },
        "CATEGORIES": {
          "TITLE": "Categorieën in",
          "NEW_CATEGORY": "Nieuwe categorie",
          "TABLE": {
            "NAME": "Naam",
            "DESCRIPTION": "Beschrijving",
            "LOCALE": "Taal",
            "ARTICLE_COUNT": "Aantal artikelen",
            "ACTION_BUTTON": {
              "EDIT": "Categorie bewerken",
              "DELETE": "Categorie verwijderen"
            },
            "EMPTY_TEXT": "Geen categorieën gevonden"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Basisinstellingen bijwerken"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Helpcentrum informatie",
            "BODY": "Basisinformatie over de portal"
          },
          "CUSTOMIZATION": {
            "TITLE": "Helpcentrum aanpassen",
            "BODY": "Portal aanpassen"
          },
          "FINISH": {
            "TITLE": "Voilà! 🎉",
            "BODY": "Je bent helemaal klaar!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Terug",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Portal aanmaken",
            "TITLE": "Helpcentrum informatie",
            "CREATE_BASIC_SETTING_BUTTON": "Basisinstellingen van portal aanmaken"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Portal aanpassen",
            "TITLE": "Helpcentrum aanpassen",
            "UPDATE_PORTAL_BUTTON": "Portalinstellingen bijwerken"
          },
          "FINISH_PAGE": {
            "TITLE": "Voilà!🎉 Je bent helemaal klaar!",
            "MESSAGE": "Je kunt deze aangemaakte portal nu zien op de pagina met al je portals.",
            "FINISH": "Ga naar de pagina met alle portals"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Logo uploaden",
          "HELP_TEXT": "Dit logo wordt weergegeven in de portalheader.",
          "IMAGE_UPLOAD_SUCCESS": "Logo succesvol geüpload",
          "IMAGE_UPLOAD_ERROR": "Logo succesvol verwijderd",
          "IMAGE_DELETE_ERROR": "Fout bij het verwijderen van het logo"
        },
        "NAME": {
          "LABEL": "Naam",
          "PLACEHOLDER": "Portal naam",
          "HELP_TEXT": "De naam wordt intern gebruikt in de publiek zichtbare portal.",
          "ERROR": "Naam is vereist"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal slug voor URL's",
          "ERROR": "Slug is vereist"
        },
        "DOMAIN": {
          "LABEL": "Aangepast domein",
          "PLACEHOLDER": "Aangepast domein van portal",
          "HELP_TEXT": "Voeg dit alleen toe als je een aangepast domein wilt gebruiken voor je portals. Bijv.: {exampleURL}",
          "ERROR": "Voer een geldige domein-URL in"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Link naar homepagina",
          "PLACEHOLDER": "Link naar homepagina van portal",
          "HELP_TEXT": "De link die wordt gebruikt om vanuit de portal terug te keren naar de homepagina. Bijv.: {exampleURL}",
          "ERROR": "Voer een geldige URL voor de homepagina in"
        },
        "THEME_COLOR": {
          "LABEL": "Themakleur van portal",
          "HELP_TEXT": "Deze kleur wordt gebruikt als themakleur voor de portal."
        },
        "PAGE_TITLE": {
          "LABEL": "Paginatitel",
          "PLACEHOLDER": "Paginatitel van portal",
          "HELP_TEXT": "De paginatitel wordt gebruikt in de openbare portal.",
          "ERROR": "Paginatitel is vereist"
        },
        "HEADER_TEXT": {
          "LABEL": "Headertekst",
          "PLACEHOLDER": "Headertekst van portal",
          "HELP_TEXT": "De headertekst van de portal wordt gebruikt in de openbare portal.",
          "ERROR": "Headertekst van portal is vereist"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portal succesvol aangemaakt.",
          "ERROR_MESSAGE_FOR_BASIC": "Kon de portal niet aanmaken. Probeer het opnieuw.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portal succesvol bijgewerkt.",
          "ERROR_MESSAGE_FOR_UPDATE": "Kon de portal niet bijwerken. Probeer het opnieuw."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Voeg een nieuwe taal toe",
        "SUB_TITLE": "Dit voegt een nieuwe taal toe aan je lijst met beschikbare vertalingen.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Taal",
          "PLACEHOLDER": "Kies een taal",
          "ERROR": "Taal is vereist"
        },
        "BUTTONS": {
          "CREATE": "Taal aanmaken",
          "CANCEL": "Annuleren"
        },
        "API": {
          "SUCCESS_MESSAGE": "Taal succesvol toegevoegd",
          "ERROR_MESSAGE": "Kan de taal niet toevoegen. Probeer het opnieuw."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Standaardtaal succesvol bijgewerkt",
          "ERROR_MESSAGE": "Kan de standaardtaal niet bijwerken. Probeer het opnieuw."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Taal succesvol verwijderd uit de portal",
          "ERROR_MESSAGE": "Kan de taal niet verwijderen uit de portal. Probeer het opnieuw."
        }
      }
    },
    "TABLE": {
      "404": "Geen artikelen komen overeen met je zoekopdracht 🔍",
      "LOADING_MESSAGE": "Artikelen laden...",
      "NO_ARTICLES": "Er zijn geen artikelen beschikbaar",
      "HEADERS": {
        "TITLE": "Titel",
        "CATEGORY": "Categorie",
        "READ_COUNT": "Weergaven",
        "STATUS": "Status",
        "LAST_EDITED": "Laatst bewerkt"
      },
      "COLUMNS": {
        "BY": "door",
        "AUTHOR_NOT_AVAILABLE": "Auteur is niet beschikbaar"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Artikel laden...",
      "TITLE_PLACEHOLDER": "Titel van artikel hier",
      "CONTENT_PLACEHOLDER": "Schrijf hier je artikel",
      "API": {
        "ERROR": "Fout bij het opslaan van het artikel"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Fout bij het publiceren van het artikel",
        "SUCCESS": "Artikel succesvol gepubliceerd"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Fout bij het archiveren van het artikel",
        "SUCCESS": "Artikel succesvol gearchiveerd"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Fout bij het als draft opslaan van het artikel",
        "SUCCESS": "Artikel succesvol als draft opgeslagen"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Verwijderen bevestigen",
          "MESSAGE": "Weet je zeker dat je het artikel wilt verwijderen?",
          "YES": "Ja, verwijderen",
          "NO": "Nee, Bewaar het"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Artikel succesvol verwijderd",
        "ERROR_MESSAGE": "Fout bij het verwijderen van het artikel"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Voeg eerst een titel en inhoud toe aan het artikel voordat je de instellingen kunt bijwerken"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Zoek naar artikelen"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Maak een categorie aan",
        "SUB_TITLE": "De categorie wordt gebruikt in de openbare portal om artikelen te categoriseren.",
        "PORTAL": "Portal",
        "LOCALE": "Taal",
        "NAME": {
          "LABEL": "Naam",
          "PLACEHOLDER": "Categorienaam",
          "HELP_TEXT": "De categorienaam en het icoon worden gebruikt in de openbare portal om artikelen te categoriseren.",
          "ERROR": "Naam is vereist"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Categorie slug voor URL's",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug is vereist"
        },
        "DESCRIPTION": {
          "LABEL": "Beschrijving",
          "PLACEHOLDER": "Geef een korte beschrijving van de categorie.",
          "ERROR": "Omschrijving is vereist"
        },
        "BUTTONS": {
          "CREATE": "Categorie aanmaken",
          "CANCEL": "Annuleren"
        },
        "API": {
          "SUCCESS_MESSAGE": "Categorie succesvol aangemaakt",
          "ERROR_MESSAGE": "Kan de categorie niet aanmaken"
        }
      },
      "EDIT": {
        "TITLE": "Bewerk een categorie",
        "SUB_TITLE": "Het bewerken van een categorie werkt de categorie bij in de openbare portal.",
        "PORTAL": "Portal",
        "LOCALE": "Taal",
        "NAME": {
          "LABEL": "Naam",
          "PLACEHOLDER": "Categorienaam",
          "HELP_TEXT": "De categorienaam en het icoon worden gebruikt in de openbare portal om artikelen te categoriseren.",
          "ERROR": "Naam is vereist"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Categorie slug voor URL's",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug is vereist"
        },
        "DESCRIPTION": {
          "LABEL": "Beschrijving",
          "PLACEHOLDER": "Geef een korte beschrijving van de categorie.",
          "ERROR": "Omschrijving is vereist"
        },
        "BUTTONS": {
          "CREATE": "Categorie bijwerken",
          "CANCEL": "Annuleren"
        },
        "API": {
          "SUCCESS_MESSAGE": "Categorie succesvol bijgewerkt",
          "ERROR_MESSAGE": "Kan de categorie niet bijwerken"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Categorie succesvol verwijderd",
          "ERROR_MESSAGE": "Kan de categorie niet verwijderen"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Artikelen zoeken",
      "PLACEHOLDER": "Zoek artikelen",
      "NO_RESULT": "Geen artikelen gevonden",
      "SEARCHING": "Zoeken...",
      "SEARCH_BUTTON": "Zoeken",
      "INSERT_ARTICLE": "Link invoegen",
      "IFRAME_ERROR": "URL is leeg of ongeldig. Kan de inhoud niet weergeven.",
      "OPEN_ARTICLE_SEARCH": "Artikel invoegen vanuit Helpcentrum",
      "SUCCESS_ARTICLE_INSERTED": "Artikel succesvol ingevoegd",
      "PREVIEW_LINK": "Voorbeeld van artikel",
      "CANCEL": "Sluiten",
      "BACK": "Terug",
      "BACK_RESULTS": "Terug naar resultaten"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Helpcentrum",
      "DESCRIPTION": "Maak gebruiksvriendelijke selfserviceportals. Help je gebruikers om toegang te krijgen tot artikelen en 24/7 ondersteuning te krijgen. Upgrade je abonnement om deze functie in te schakelen.",
      "SELF_HOSTED_DESCRIPTION": "Maak gebruiksvriendelijke selfserviceportals. Help je gebruikers om toegang te krijgen tot artikelen en 24/7 ondersteuning te krijgen. Neem contact op met je beheerder om deze functie in te schakelen.",
      "BUTTON": {
        "LEARN_MORE": "Meer informatie",
        "UPGRADE": "Upgraden"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Meerdere portals",
          "DESCRIPTION": "Maak meerdere helpcentrum-portals voor verschillende producten binnen hetzelfde account."
        },
        "LOCALES": {
          "TITLE": "Volledige ondersteuning voor talen",
          "DESCRIPTION": "Lokaliseer de portal in jouw taal. We ondersteunen alle talen en maken vertalingen voor elk artikel mogelijk."
        },
        "SEO": {
          "TITLE": "SEO-vriendelijk ontwerp",
          "DESCRIPTION": "Pas je metatags aan om je zichtbaarheid in zoekmachines te verbeteren met onze SEO-vriendelijke pagina's."
        },
        "API": {
          "TITLE": "Volledige API-ondersteuning",
          "DESCRIPTION": "Gebruik de portal als een headless CMS met front-end frameworks van derden via onze API's."
        }
      }
    },
    "LOADING": "Laden...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} weergave | {count} weergaven",
          "DROPDOWN_MENU": {
            "PUBLISH": "Publiceren",
            "DRAFT": "Draft",
            "ARCHIVE": "Archiveren",
            "DELETE": "Verwijderen"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Gepubliceerd",
            "ARCHIVED": "Gearchiveerd"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Zonder categorie"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Alle artikelen",
          "MINE": "Mijn",
          "DRAFT": "Draft",
          "PUBLISHED": "Gepubliceerd",
          "ARCHIVED": "Gearchiveerd"
        },
        "CATEGORY": {
          "ALL": "Alle categorieën"
        },
        "LOCALE": {
          "ALL": "Alle talen"
        },
        "NEW_ARTICLE": "Nieuw artikel"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Schrijf een artikel",
          "SUBTITLE": "Schrijf een uitgebreid artikel, laten we beginnen!",
          "BUTTON_LABEL": "Nieuw artikel"
        },
        "MINE": {
          "TITLE": "Je hebt hier nog geen artikelen geschreven",
          "SUBTITLE": "Alle artikelen die jij hebt geschreven verschijnen hier voor snelle toegang."
        },
        "DRAFT": {
          "TITLE": "Er zijn geen artikelen in drafts",
          "SUBTITLE": "Draft-artikelen verschijnen hier"
        },
        "PUBLISHED": {
          "TITLE": "Er zijn geen gepubliceerde artikelen",
          "SUBTITLE": "Gepubliceerde artikelen verschijnen hier"
        },
        "ARCHIVED": {
          "TITLE": "Er zijn geen artikelen in het archief",
          "SUBTITLE": "Gearchiveerde artikelen worden niet weergegeven op de portal, je kunt dit gebruiken om verouderde of achterhaalde pagina's te markeren"
        },
        "CATEGORY": {
          "TITLE": "Er zijn geen artikelen in deze categorie",
          "SUBTITLE": "Artikelen in deze categorie verschijnen hier"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Nieuwe categorie",
        "EDIT_CATEGORY": "Categorie bewerken",
        "CATEGORIES_COUNT": "{n} categorie | {n} categorieën",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Categorieën ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} artikelen) | {categoryName} ({categoryCount} artikel)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Geen categorieën gevonden",
        "SUBTITLE": "Categorieën verschijnen hier. Je kunt een categorie toevoegen door op de knop 'Nieuwe categorie' te klikken."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} artikel | {count} artikelen",
        "EXPAND": "Subcategorieën weergeven",
        "COLLAPSE": "Subcategorieën verbergen",
        "MENU": {
          "NEW_ARTICLE": "Nieuw artikel",
          "ADD_SUBCATEGORY": "Subcategorie toevoegen",
          "EDIT": "Bewerken",
          "DELETE": "Verwijderen"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Categorie succesvol aangemaakt",
            "ERROR_MESSAGE": "Kan de categorie niet aanmaken"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Categorie succesvol bijgewerkt",
            "ERROR_MESSAGE": "Kan de categorie niet bijwerken"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Categorie succesvol verwijderd",
            "ERROR_MESSAGE": "Kan de categorie niet verwijderen"
          },
          "CONFIRM": {
            "TITLE": "Categorie verwijderen",
            "DESCRIPTION": "Weet je zeker dat je deze categorie wilt verwijderen? De bijbehorende artikelen worden ongecategoriseerd.",
            "DESCRIPTION_WITH_CHILDREN": "Weet je zeker dat je deze categorie wilt verwijderen? De bijbehorende artikelen worden ongecategoriseerd en de {count} subcategorie wordt naar het hoogste niveau verplaatst. | Weet je zeker dat je deze categorie wilt verwijderen? De bijbehorende artikelen worden ongecategoriseerd en de {count} subcategorieën worden naar het hoogste niveau verplaatst.",
            "CONFIRM": "Verwijderen"
          }
        },
        "HEADER": {
          "CREATE": "Categorie aanmaken",
          "EDIT": "Categorie bewerken",
          "DESCRIPTION": "Het bewerken van een categorie werkt de categorie bij in de openbare portal.",
          "PORTAL": "Portal",
          "LOCALE": "Taal"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Naam",
            "PLACEHOLDER": "Categorienaam",
            "ERROR": "Naam is vereist"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Categorie slug voor URL's",
            "ERROR": "Slug is vereist",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Beschrijving",
            "PLACEHOLDER": "Geef een korte beschrijving van de categorie.",
            "ERROR": "Omschrijving is vereist"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Bovenliggende categorie",
            "PLACEHOLDER": "Selecteer een bovenliggende categorie",
            "NONE": "Geen (hoogste niveau)"
          }
        },
        "BUTTONS": {
          "CREATE": "Aanmaken",
          "EDIT": "Bijwerken",
          "CANCEL": "Annuleren"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Geen talen beschikbaar | {n} taal | {n} talen",
      "NEW_LOCALE_BUTTON_TEXT": "Nieuwe taal",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} artikel | {count} artikelen",
        "CATEGORIES_COUNT": "{count} categorie | {count} categorieën",
        "DEFAULT": "Standaard",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Instellen als standaard",
          "DELETE": "Verwijderen"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Voeg een nieuwe taal toe",
        "DESCRIPTION": "Selecteer de taal waarin dit artikel wordt geschreven. Dit wordt toegevoegd aan je lijst met vertalingen; je kunt er later meer toevoegen.",
        "COMBOBOX": {
          "PLACEHOLDER": "Selecteer taal..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Taal succesvol toegevoegd",
          "ERROR_MESSAGE": "Kan de taal niet toevoegen. Probeer het opnieuw."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Opslaan...",
          "SAVED": "Opgeslagen"
        },
        "PREVIEW": "Voorbeeld",
        "PUBLISH": "Publiceren",
        "DRAFT": "Draft",
        "ARCHIVE": "Archiveren",
        "BACK_TO_ARTICLES": "Terug naar artikelen"
      },
      "DRAFT": {
        "PENDING_LABEL": "Niet-gepubliceerde wijzigingen",
        "PROMOTE": "Wijzigingen publiceren",
        "DISCARD": "Wijzigingen verwijderen",
        "PROMOTE_SUCCESS": "Draft-wijzigingen gepubliceerd naar het live artikel",
        "PROMOTE_ERROR": "Kan de draft-wijzigingen niet publiceren",
        "DISCARD_SUCCESS": "Draft-wijzigingen verwijderd",
        "DISCARD_ERROR": "Kan de draft-wijzigingen niet verwijderen"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Versiegeschiedenis",
        "TITLE": "Versiegeschiedenis",
        "BACK": "Terug naar artikel",
        "LOADING": "Versies laden...",
        "EMPTY": "Nog geen versies. Wijzigingen aan dit artikel verschijnen hier.",
        "EMPTY_CONTENT": "Deze versie heeft geen inhoud.",
        "CURRENT_BADGE": "Huidig",
        "RESTORED_BADGE": "Hersteld",
        "AUTOMATED_USER": "Automatische update",
        "RESTORE": "Deze versie herstellen",
        "RESTORE_DIALOG": {
          "TITLE": "Deze versie herstellen?",
          "DESCRIPTION": "Het artikel wordt teruggezet naar de tekst van deze versie. Er gaat niets verloren — de huidige tekst blijft in de geschiedenis staan, en een gepubliceerd artikel blijft de live versie tonen totdat je de wijziging publiceert.",
          "CONFIRM": "Herstellen"
        },
        "RESTORE_SUCCESS": "Versie hersteld",
        "RESTORE_ERROR": "Kan deze versie niet herstellen",
        "FETCH_ERROR": "Kan de versiegeschiedenis niet laden"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Meer eigenschappen",
        "TRANSLATE": "Vertalen",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Zonder categorie",
        "EDITOR_PLACEHOLDER": "Schrijf iets...",
        "HTML_EMBED": {
          "TITLE": "Aangepaste HTML invoegen",
          "DESCRIPTION": "Plak ruwe HTML zoals een iframe, embed of widgetfragment. Het wordt ongewijzigd weergegeven in het gepubliceerde artikel.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Invoegen"
        },
        "PRIMARY_CATEGORY": "Primaire categorie"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Artikeleigenschappen",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Metabeschrijving",
        "META_DESCRIPTION_PLACEHOLDER": "Voeg metabeschrijving toe",
        "META_TITLE": "Metatitel",
        "META_TITLE_PLACEHOLDER": "Voeg metatitel toe",
        "META_TAGS": "Metatags",
        "META_TAGS_PLACEHOLDER": "Voeg metatags toe",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Taalvarianten",
        "LANGUAGE_MUTATIONS_EMPTY": "Nog geen gekoppelde artikelen",
        "ADD_MUTATION": "Toevoegen",
        "REMOVE_MUTATION": "Verwijderen"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Taalvarianten koppelen",
        "SEARCH_PLACEHOLDER": "Zoek artikelen op titel",
        "EMPTY": "Geen overeenkomende artikelen",
        "CANCEL": "Annuleren",
        "ADD_SELECTED": "Selectie toevoegen",
        "SUCCESS": "Varianten bijgewerkt",
        "ERROR": "Bijwerken van varianten mislukt"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Artikel vertalen",
        "DESCRIPTION": "Selecteer de talen waarnaar je dit artikel wilt vertalen. Talen die al vertaald zijn, worden opnieuw vertaald naar een draft ter beoordeling.",
        "EMPTY": "Er zijn geen andere talen beschikbaar.",
        "CONNECTED_BADGE": "Vertaald",
        "CANCEL": "Annuleren",
        "TRANSLATE": "Vertalen",
        "SUCCESS": "De vertaling start binnenkort. De vertaalde artikelen verschijnen spoedig als taalvarianten.",
        "ERROR": "Starten van de vertaling mislukt"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Fout bij het opslaan van het artikel"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Nieuwe portal",
      "PORTALS": "Portals",
      "CREATE_PORTAL": "Maak en beheer meerdere portals",
      "ARTICLES": "artikelen",
      "DOMAIN": "domeinnaam",
      "PORTAL_NAME": "Portal naam"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Nieuwe portal aanmaken",
      "DESCRIPTION": "Geef je portal een naam en maak een gebruiksvriendelijke URL-slug. Je kunt beide later aanpassen in de instellingen.",
      "CONFIRM_BUTTON_LABEL": "Aanmaken",
      "NAME": {
        "LABEL": "Naam",
        "PLACEHOLDER": "Gebruikershandleiding",
        "MESSAGE": "Kies een naam voor je portal.",
        "ERROR": "Naam is vereist"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug is vereist",
        "FORMAT_ERROR": "Gebruik alleen letters, cijfers en koppeltekens, bijvoorbeeld: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Kon afbeelding niet uploaden! Probeer het opnieuw",
          "IMAGE_UPLOAD_SUCCESS": "Afbeelding succesvol toegevoegd. Klik op 'Wijzigingen opslaan' om het logo op te slaan",
          "IMAGE_DELETE_SUCCESS": "Logo succesvol verwijderd",
          "IMAGE_DELETE_ERROR": "Kan het logo niet verwijderen",
          "IMAGE_UPLOAD_SIZE_ERROR": "De grootte van de afbeelding moet kleiner zijn dan {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Naam",
          "PLACEHOLDER": "Portal naam",
          "ERROR": "Naam is vereist"
        },
        "HEADER_TEXT": {
          "LABEL": "Headertekst",
          "PLACEHOLDER": "Headertekst van portal"
        },
        "PAGE_TITLE": {
          "LABEL": "Paginatitel",
          "PLACEHOLDER": "Paginatitel van portal"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Link naar homepagina",
          "PLACEHOLDER": "Link naar homepagina van portal",
          "ERROR": "Ongeldige URL. De link naar de homepagina moet beginnen met 'http://' of 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Portal slug"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Livechatwidget",
          "PLACEHOLDER": "Selecteer livechatwidget",
          "HELP_TEXT": "Selecteer een livechatwidget die wordt weergegeven op je helpcentrum"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Openbaar toegankelijk",
          "HELP_TEXT": "Maak de portal toegankelijk voor iedereen met de link.",
          "OPTIONS": {
            "PUBLIC": "Ja",
            "PRIVATE": "Nee"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Linkbestemming",
          "HELP_TEXT": "Kies of links in artikelen in het huidige venster of in een nieuw venster worden geopend.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Huidig venster",
            "NEW_WINDOW": "Nieuw venster"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Standaard afbeeldingsgrootte",
          "HELP_TEXT": "Grootte die wordt toegepast op elke afbeelding die je in een artikel invoegt. Kies Original om afbeeldingen op hun eigen grootte in te voegen en kies in plaats daarvan een grootte per afbeelding."
        },
        "BRAND_COLOR": {
          "LABEL": "Merkkleur"
        },
        "CUSTOM_HTML": {
          "LABEL": "Aangepaste HTML",
          "PLACEHOLDER": "<!-- Plak hier je analytics- of trackingcode -->",
          "HELP_TEXT": "Wordt ingevoegd aan het begin van de <body>-tag op elke Helpcentrum-pagina. Gebruik dit voor Google Analytics, Google Tag Manager of een andere trackingcode. De code wordt exact weergegeven zoals ingevoerd en wordt niet gevalideerd."
        },
        "SAVE_CHANGES": "Wijzigingen opslaan"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Aangepast domein",
          "LABEL": "Aangepast domein:",
          "DESCRIPTION": "Je kunt je portal hosten op een aangepast domein. Bijvoorbeeld, als je website yourdomain.com is en je wilt dat je portal beschikbaar is op docs.yourdomain.com, voer dat dan in dit veld in.",
          "PLACEHOLDER": "Aangepast domein van portal",
          "EDIT_BUTTON": "Aangepast domein bewerken",
          "ADD_BUTTON": "Aangepast domein toevoegen",
          "DIALOG": {
            "ADD_HEADER": "Aangepast domein toevoegen",
            "EDIT_HEADER": "Aangepast domein bewerken",
            "ADD_CONFIRM_BUTTON_LABEL": "Domein toevoegen",
            "EDIT_CONFIRM_BUTTON_LABEL": "Domein bijwerken",
            "LABEL": "Aangepast domein",
            "PLACEHOLDER": "Aangepast domein van portal",
            "ERROR": "Aangepast domein is vereist"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "DNS-configuratie",
            "DESCRIPTION": "Log in bij je DNS-provider en voeg het onderstaande CNAME-record toe voor je subdomein.",
            "HELP_TEXT": "Zodra dit is gedaan, kun je contact opnemen met onze support om het automatisch gegenereerde SSL-certificaat aan te vragen.",
            "CONFIRM_BUTTON_LABEL": "Begrepen!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "{portalName} verwijderen",
          "HEADER": "Portal verwijderen",
          "DESCRIPTION": "Verwijder deze portal permanent. Deze actie kan niet ongedaan worden gemaakt",
          "DIALOG": {
            "HEADER": "Weet je zeker dat je {portalName} wilt verwijderen?",
            "DESCRIPTION": "Dit is een permanente actie die niet ongedaan kan worden gemaakt.",
            "CONFIRM_BUTTON_LABEL": "Verwijderen"
          }
        },
        "EDIT_CONFIGURATION": "Configuratie bewerken"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal succesvol aangemaakt",
          "ERROR_MESSAGE": "Kan de portal niet aanmaken"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal succesvol bijgewerkt",
          "ERROR_MESSAGE": "Kan de portal niet bijwerken"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Bijlagen",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Bestand toevoegen",
      "DROP_HERE": "Sleep bestanden hierheen",
      "COPY_LINK": "Link kopiëren",
      "LINK_COPIED": "Link gekopieerd naar klembord",
      "COPY_FAILED": "Kopiëren van link mislukt",
      "DELETE": "Verwijderen",
      "CANCEL": "Annuleren",
      "QUEUED": "In wachtrij",
      "UPLOADING": "Uploaden",
      "UPLOAD_FAILED": "Uploaden van bestand mislukt",
      "FILE_TOO_LARGE": "Bestand overschrijdt de limiet van 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Vertaalwoordenboek",
        "DESCRIPTION": "Termen die hier worden gedefinieerd, worden toegevoegd aan de AI-vertaalprompt, zodat ze altijd op dezelfde manier worden vertaald. De hoofdterm is geschreven in {locale}."
      },
      "NEW_TERM": "Nieuwe term",
      "EMPTY_STATE": {
        "TITLE": "Nog geen woordenboektermen",
        "SUBTITLE": "Voeg een term en de vertaling ervan toe voor elke taal. Wanneer een artikel wordt vertaald, worden deze termen toegepast zodat je producttaal consistent blijft."
      },
      "LIST": {
        "TERM": "Term",
        "TRANSLATIONS": "Vertalingen",
        "ACTIONS": "Acties"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Term toevoegen",
          "EDIT": "Term bewerken",
          "DESCRIPTION": "Onderstaande term wordt toegepast tijdens de AI-vertaling van je helpcentrumartikelen.",
          "PORTAL": "Portal",
          "PRIMARY_LANGUAGE": "Primaire taal"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Term ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "Term is vereist"
          },
          "DESCRIPTION": {
            "LABEL": "Context / notities (optioneel)",
            "PLACEHOLDER": "Wanneer en hoe deze term wordt gebruikt, om de vertaler te helpen de juiste betekenis te kiezen."
          },
          "TRANSLATIONS": "Vertalingen",
          "TRANSLATION_PLACEHOLDER": "Laat leeg om de AI vrij te laten vertalen",
          "AUTO_TRANSLATE": {
            "BUTTON": "Alles automatisch vertalen",
            "CONFIRM": "Vertalen naar {count} talen met AI?",
            "CONFIRM_BUTTON": "Vertalen",
            "CANCEL": "Annuleren",
            "SUCCESS": "Vertalingen gegenereerd — controleer en sla op",
            "ERROR": "Kan niet automatisch vertalen, probeer het opnieuw"
          }
        },
        "BUTTONS": {
          "CREATE": "Term toevoegen",
          "EDIT": "Opslaan",
          "CANCEL": "Annuleren"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Term succesvol toegevoegd",
            "ERROR_MESSAGE": "Kan de term niet toevoegen, probeer het opnieuw"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Term succesvol bijgewerkt",
            "ERROR_MESSAGE": "Kan de term niet bijwerken, probeer het opnieuw"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Term verwijderen",
          "DESCRIPTION": "Weet je zeker dat je deze term wilt verwijderen? Deze wordt niet meer toegepast tijdens het vertalen.",
          "CONFIRM": "Verwijderen"
        },
        "API": {
          "SUCCESS_MESSAGE": "Term succesvol verwijderd",
          "ERROR_MESSAGE": "Kan de term niet verwijderen, probeer het opnieuw"
        }
      }
    }
  }
}
